import { DeliveryMethod, DeliveryMethodDetail } from '@/models/api/delivery/deliveryMethod'
import { CartScopeEq } from '@/models/cart/group/scope'
import { ApiClient } from '@/services/api/client'
import { PurchaseService } from '@spa/services/api/purchase'
import { Payment } from '@spa/store/modules/orderConfirm/types'
import { Either, left, right } from 'fp-ts/lib/Either'
export interface DeliveryMethodDetailParams {
  cartIds: string
  payment: Payment
  deliveryId: string
  deliveryMethod: string
}

export interface DeliveryMethodServiceInterface {
  findById(id: string, params: DeliveryMethodDetailParams): Promise<Either<Error, DeliveryMethodDetail>>
  list(scope: CartScopeEq, payment: string): Promise<Either<Error, DeliveryMethod[]>>
  getPresetMethod(scope: CartScopeEq, payment: string): Promise<Either<Error, DeliveryMethod>>
}

export class DeliveryMethodService implements DeliveryMethodServiceInterface {
  static create(): DeliveryMethodServiceInterface {
    return new DeliveryMethodService(ApiClient)
  }
  private readonly baseEndpoint = '/api/user/delivery/delivery_method'
  private constructor(private readonly apiClient: typeof ApiClient) {}

  async findById(
    id: string,
    params: DeliveryMethodDetailParams
    ): Promise<Either<Error, DeliveryMethodDetail>> {
    const { cartIds, payment, deliveryId, deliveryMethod } = params
    try {
      // クエリ長制限回避のため、GETでなくPOSTを利用
      // @see https://my-color.esa.io/posts/545
      const res = await this.apiClient.post(`${this.baseEndpoint}/${id}`, {
        cart_ids: cartIds,
        payment: this.makePaymentParam(payment),
        delivery: JSON.stringify({
          delivery_type: 'registered',
          id: deliveryId,
          delivery_method: deliveryMethod,
        }),
      })

      return right(res.body.data)
    } catch (e) {
      return left(e)
    }
  }

  async list(scope: CartScopeEq, payment: string): Promise<Either<Error, DeliveryMethod[]>> {
    try {
      const res = await this.apiClient.get(
        `${this.baseEndpoint}/${scope.kind.toString()}/${scope.value.toString()}`,
        { payment }
      )

      return right(res.body.data)
    } catch (e) {
      return left(e)
    }
  }

  async getPresetMethod(scope: CartScopeEq, payment: string): Promise<Either<Error, DeliveryMethod>> {
    try {
      const res = await this.apiClient.get(
        `${this.baseEndpoint}/preset/${scope.kind.toString()}/${scope.value.toString()}`,
        { payment }
      )

      return right(res.body.data)
    } catch (e) {
      return left(e)
    }
  }

  private makePaymentParam(payment: Payment): any {
    return (new PurchaseService()).makeEstimatePaymentParam(payment).fold(
      (l: Error) => { throw l },
      (r: string) => r
    )
  }
}
